import { render, staticRenderFns } from "./games.vue?vue&type=template&id=4beb9501&scoped=true&"
import script from "./games.vue?vue&type=script&lang=ts&"
export * from "./games.vue?vue&type=script&lang=ts&"
import style0 from "./games.vue?vue&type=style&index=0&id=4beb9501&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beb9501",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogAcfBlocks: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/blog/BlogAcfBlocks.vue').default})
